module.exports = __webpack_public_path__ + "static/one-pitch-at-a-time-title-6eb8a81161f4e9724b8abf553c565a80.png";